import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth';
import { SettingsService, User } from '@delon/theme';
import { AuthService } from 'src/app/core/util/auth.service';

import { MobileAppQrCodeComponent } from './mobile-app-qr-code/mobile-app-qr-code.component';
import { ACLService } from '@delon/acl';

@Component({
  selector: 'header-user',
  standalone: false,
  template: `
    <div
      class="alain-default__nav-item d-flex align-items-center px-sm mobile-min-width-user"
      nz-dropdown
      nzPlacement="bottomCenter"
      [nzDropdownMenu]="userMenu"
    >
      <nz-avatar
        [nzSrc]="user['pictureUrl']"
        nzIcon="user"
        nzSize="small"
        class="mr-sm"
        style="background-color:#1d4478"
      ></nz-avatar>
<span class="hide-this">{{ user['displayName'] }}</span>
    </div>
      <nz-dropdown-menu #userMenu="nzDropdownMenu">
        <div nz-menu class="width-md header-extend">
          <div nz-menu-item routerLink="/account/companies">
            <i nz-icon nzType="appstore" class="mr-sm"></i>
            My Companies
          </div>
          <div nz-menu-item routerLink="/account/settings">
            <i nz-icon nzType="setting" class="mr-sm"></i>
            Account Settings
          </div>
          <div nz-menu-item routerLink="/company/adv-opts">
            <i nz-icon nzType="tool" class="mr-sm"></i>
            Advanced Options
          </div>

          <div
          *ngIf="company && !company['isSample'] && (company['isOwner'] || acl.can({ ability: ['subscription.view'], mode: 'allOf' }))"
            nz-menu-item
            (click)="showManagePlan()"
          >
            <i nz-icon nzType="container" class="mr-sm"></i>
            Manage Plan
          </div>

          <li nz-menu-divider></li>
          <div nz-menu-item>
            <i nz-icon nzType="read" class="mr-sm"></i>
            <a
              style="color: unset;"
              [href]="this.academyLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              QNE Academy
            </a>
          </div>
          <div nz-menu-item>
            <i nz-icon nzType="global" class="mr-sm"></i>
            <a
              style="color: unset;"
              [href]="this.websiteLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              QNE Website
            </a>
          </div>
          <div nz-menu-item>
            <i nz-icon nzType="read" class="mr-sm"></i>
            <a
              style="color: unset;"
              [href]="this.youtubeLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Youtube Channel
            </a>
          </div>

          <li nz-menu-divider></li>
          <div nz-menu-item (click)="mobileAppQrCodeComponent.show()">
            <i nz-icon nzType="mobile" class="mr-sm"></i>
            Get QNE Accounting App
          </div>

          <div
            nz-menu-item
            *ngIf="this.acl.can({ ability: ['lic.paid'] })"
          >
            <i nz-icon nzType="history" class="mr-sm"></i>
            <a
              style="color: unset;"
              [href]="releaseNotesLink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Release Notes
            </a>
          </div>
          <li nz-menu-divider></li>
          <div nz-menu-item (click)="fullscreenRef.toggle()">
            <header-fullscreen #fullscreenRef></header-fullscreen>
          </div>
          <li nz-menu-divider></li>
          <div nz-menu-item (click)="logout()">
            <i nz-icon nzType="logout" class="mr-sm"></i>
            Logout
          </div>
        </div>
      </nz-dropdown-menu>

    <!-- Mobile app QR code modal -->
    <app-mobile-app-qr-code #mobileAppQrCodeComponent></app-mobile-app-qr-code>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderUserComponent {
  @ViewChild('mobileAppQrCodeComponent')
  mobileAppQrCode!: MobileAppQrCodeComponent;

  get user(): User {
    return this.settings.user;
  }
  get country() {
    return this.settings.user['company']?.country;
  }
  get academyLink() {
    if (this.country === 'PH') return 'https://academy.qne.cloud';

    return 'https://academy.qne.cloud/courses/qcamy';
  }
  get websiteLink() {
    if (this.country === 'PH') return 'https://qne.cloud/ph/';

    return 'https://qne.cloud/my/';
  }
  get youtubeLink() {
    if (this.country === 'PH') return 'https://www.youtube.com/@QNESoftwarePH';

    return 'https://www.youtube.com/@QnESoftwareChannel';
  }
  get releaseNotesLink() {
    if (this.country === 'PH') {
      return 'https://support-ph.qne.cloud/support/solutions/folders/35000252635';
    }
    return 'https://support.qne.com.my/support/solutions/folders/81000302605';
  }
  get company() {
    return this.settings.user['company'];
  }

  constructor(
    private settings: SettingsService,
    private authService: AuthService,
    private router: Router,
    public acl: ACLService,
    @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService
  ) {
    // obsolete: retrieve release notes by country
    // this.http
    //   .get(
    //     `api/releaseNotes/getByCountry?country=${this.country}&_silent=true`,
    //     {},
    //     { context: new HttpContext().set(ALLOW_ANONYMOUS, true) }
    //   )
    //   .subscribe((res: any[]) => {
    //     this.releaseNotes = [...res];
    //   });
  }

  logout(): void {
    this.authService.logout();
  }

  showManagePlan() {
    const tokenModel = this.tokenService.get();

    if (tokenModel) {
      const currentTenantId = tokenModel['tenantId'];

      this.router.navigate(['./account/subscription'], {
        queryParams: { tid: currentTenantId }
      });
    } else {
      // Handle the case when tokenModel is null
      // You can display an error message or take appropriate action
    }
  }
}
